import { render } from "./TSSW.vue?vue&type=template&id=41b8517a"
import script from "./TSSW.vue?vue&type=script&lang=js"
export * from "./TSSW.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__